const numberFilters = (href: string): number => {
  const url = new URL(href);

  const numberSegments = url.pathname.split('/');
  const isEntryKey = numberSegments[1] === 'entry-key';
  const baseSegments = isEntryKey ? 3 : 2;

  if (numberSegments.length > baseSegments) {
    return url.searchParams.size + 1;
  }

  return url.searchParams.size;
};

export default numberFilters;
